import axios from 'axios';

class DrugAccessService {
    constructor() {
        this.state = {
            apiUrl: process.env.REACT_APP_API_URL,
        };
    }

    getAllBrandName(customerId, brandName) {
        const url =
            this.state.apiUrl + 'drugconfig/getAllBrandName?customerId=' + customerId + '&brandName=' + brandName;
        if (
            url.includes(
                this.state.apiUrl + 'drugconfig/getAllBrandName?customerId=' + customerId + '&brandName=' + brandName,
            )
        ) {
            return axios
                .get(url)
                .then((res) => {
                    return res.data;
                })
                .catch((err) => {
                    return err;
                });
        }
    }

    getAllGPI10(customerId, gpi10) {
        const url = this.state.apiUrl + 'drugconfig/getAllGPI10?customerId=' + customerId + '&gpi10=' + gpi10;
        if (url.includes(this.state.apiUrl + 'drugconfig/getAllGPI10?customerId=' + customerId + '&gpi10=' + gpi10)) {
            return axios
                .get(url, {
                    
                })
                .then((res) => {
                    return res.data;
                })
                .catch((err) => {
                    return err;
                });
        }
    }

    getAllDrugConfigList(brandName, gpi10, isIncluded, customerId, selectedClass) {
        console.log('brandName, gpi10,', brandName, gpi10);

        if (brandName == null) {
            brandName = '';
        }

        if (gpi10 == null) {
            gpi10 = '';
        }

        if (selectedClass == null) {
            selectedClass = '';
        }

        const url =
            this.state.apiUrl +
            'drugconfig/getAllDrugConfigList?customerId=' +
            customerId +
            '&isIncluded=' +
            isIncluded +
            '&brandName=' +
            brandName +
            '&gpi10=' +
            gpi10 +
            '&selectedClass=' +
            selectedClass;
        if (
            url.includes(
                this.state.apiUrl +
                    'drugconfig/getAllDrugConfigList?customerId=' +
                    customerId +
                    '&isIncluded=' +
                    isIncluded +
                    '&brandName=' +
                    brandName +
                    '&gpi10=' +
                    gpi10 +
                    '&selectedClass=' +
                    selectedClass,
            )
        ) {
            return axios
                .get(url)
                .then((res) => {
                    return res.data;
                })
                .catch((err) => {
                    return err;
                });
        }
    }

    getAllDrugConfigClassList(customerId, isIncluded, brandName, gpi10) {
        if (brandName == null) {
            brandName = '';
        }

        if (gpi10 == null) {
            gpi10 = '';
        }

        const url =
            this.state.apiUrl +
            'drugconfig/getAllDrugConfigClassList?customerId=' +
            customerId +
            '&isIncluded=' +
            isIncluded +
            '&brandName=' +
            brandName +
            '&gpi10=' +
            gpi10;
        if (
            url.includes(
                this.state.apiUrl +
                    'drugconfig/getAllDrugConfigClassList?customerId=' +
                    customerId +
                    '&isIncluded=' +
                    isIncluded +
                    '&brandName=' +
                    brandName +
                    '&gpi10=' +
                    gpi10,
            )
        ) {
            return axios
                .get(url)
                .then((res) => {
                    return res.data;
                })
                .catch((err) => {
                    return err;
                });
        }
    }

    updateDrugConfig(customerId, data) {
        const url = this.state.apiUrl + 'drugconfig/updateDrugConfig?id=' + customerId;
        if (url.includes(this.state.apiUrl + 'drugconfig/updateDrugConfig?id=' + customerId)) {
            return axios
                .put(url, data)
                .then((res) => {
                    return res.data;
                })
                .catch((err) => {
                    return err;
                });
        }
    }
}
export default DrugAccessService;
